<template>
  <Dialog
    title="导入草稿"
    :modelValue="modelValue"
    @onClosed="handleClosed"
    @onConfirm="handleConfirm"
    width="60%"
  >
    <template #content>
      <Table
        :data="tableData"
        ref="tableRef"
        :columns="columns"
        maxHeight="500"
        :showSearchIcon="true"
        :total="total"
        :loading="loading"
        :showFun="false"
        :isSelect="true"
        :isRadio="true"
        rowKey="outInRecordsId"
        @onSearch="handleSearch"
      />
    </template>
  </Dialog>
</template>

<script setup>
import Dialog from "@/components/Element/Dialog";
import Table from "@/components/Element/Table";
import { listOutInputRecordsDraft } from "@/api/warehouse/outInWarehouse";
import { ref, onMounted, watch } from "vue";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  searchData: {
    type: Object,
    default: () => ({}),
  },
  columns: {
    type: Array,
    default: () => [],
  },
});

const emits = defineEmits(["update:modelValue", "success"]);

const tableRef = ref(null);
const tableData = ref([]);
const total = ref(0);
const loading = ref(false);

const handleClosed = () => {
  emits("update:modelValue", false);
};

const handleSearch = (data) => {
  loading.value = true;
  listOutInputRecordsDraft({
    ...data,
    ...props.searchData,
  })
    .then((res) => {
      tableData.value = res.data;
      total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
    })
    .catch((res) => {})
    .finally(() => {
      loading.value = false;
    });
};

const handleConfirm = () => {
  emits("success", tableRef.value.getSelectedRows());
  handleClosed();
};

onMounted(() => {
  watch(
    () => props.modelValue,
    (newVal) => {
      if (newVal && tableRef.value) {
        tableRef.value.cleanSelect();
        tableRef.value.onSearch();
      }
    }
  );
});
</script>

<style lang="scss" scoped></style>
